var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import MessageDialog from '../../parts/MessageDialog.vue';
import PinDialog from '../../parts/PinDialog.vue';
import ToolBar from "../../parts/ToolBar.vue";
import { PinCodeHelper } from "../../../lib/storage";
export default Vue.extend({
    components: {
        ToolBar,
        MessageDialog,
        PinDialog,
    },
    name: "LessonBeginnerBackupEnd",
    data() {
        return {
            showEncryptedAlready: false,
            showPinDialog: false,
        };
    },
    methods: {
        onClickedPinSettings() {
            return __awaiter(this, void 0, void 0, function* () {
                if (yield PinCodeHelper.hasSavedCode()) {
                    this.showEncryptedAlready = true;
                }
                else {
                    this.showPinDialog = true;
                }
            });
        },
        onClosedEncryptedAlready() {
            this.$router.push('/lesson/beginner_end');
        },
        onCompletedPinRegistration() {
            this.$router.push('/lesson/beginner_end');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/lesson/LessonBeginnerBackupEnd.vue
// module id = 641
// module chunks = 1